import React from 'react';

import styled from 'styled-components';
import { Text } from '@cuemath/comps';

const Img = styled.img`
  width: 17px;
  height: 17px;
  display: block;
  cursor: pointer;
  transition: transform 0.2s;
  &:hover {
    &:hover {
      transform: scale(1.2);
    }
  }
`;

const LinkText = styled(Text)`
  text-decoration: underline;
  cursor: pointer;
  color: blue;
  text-align: center;
  color: blue;
`;

const IconButton = ({ icon, onClick }) => {
  return (
    <Img
      src={icon}
      onClick={() => {
        onClick();
      }}
    />
  );
};

const LinkButton = ({ text, onClick }) => {
  return (
    <LinkText
      onClick={() => {
        onClick();
      }}
    >
      {text}
    </LinkText>
  );
};

export { IconButton, LinkButton };
